var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSites = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.594,
    height: 19.191,
    viewBox: "0 0 20.594 19.191",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_170",
    "data-name": "Rechteck 170",
    width: 20.594,
    height: 19.191,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11099",
    "data-name": "Gruppe 11099",
    transform: "translate(-10.029 -330.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11130",
    "data-name": "Gruppe 11130",
    transform: "translate(-7 -167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_11129",
    "data-name": "Gruppe 11129",
    transform: "translate(17.029 497.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_285",
    "data-name": "Gruppe 285",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_427",
    "data-name": "Pfad 427",
    d: "M17.791,16.83H13.01c-.192.34-.386.681-.579,1.015h4.577l2.269,8.624H15.117A4.571,4.571,0,0,0,10.551,21.9H9.029a2.539,2.539,0,0,1-2.537-2.537V17.845H8.163c-.193-.334-.388-.674-.579-1.015H2.8L0,27.483H20.594ZM1.316,26.469l2.27-8.624H5.478v1.522a3.555,3.555,0,0,0,3.551,3.551h1.522A3.556,3.556,0,0,1,14.1,26.469Z",
    transform: "translate(0 -8.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_428",
    "data-name": "Pfad 428",
    d: "M20.045,5.958a4.058,4.058,0,0,0,.325-1.421,2.537,2.537,0,1,0-5.073,0,4.058,4.058,0,0,0,.325,1.421,40.265,40.265,0,0,0,2.211,4.068c.145-.242.3-.5.539-.912a31.5,31.5,0,0,0,1.672-3.156M16.312,4.5a1.462,1.462,0,1,1,1.462,1.462A1.462,1.462,0,0,1,16.312,4.5",
    transform: "translate(-7.537 -0.986)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_429",
    "data-name": "Pfad 429",
    d: "M20,5.36a5.115,5.115,0,0,0,.4-1.809,3.551,3.551,0,1,0-7.1,0,5.115,5.115,0,0,0,.4,1.809,58.738,58.738,0,0,0,3.149,5.628A58.738,58.738,0,0,0,20,5.36M14.312,3.551a2.537,2.537,0,0,1,5.073,0,4.063,4.063,0,0,1-.325,1.421A40.168,40.168,0,0,1,16.848,9.04a40.262,40.262,0,0,1-2.211-4.068,4.063,4.063,0,0,1-.325-1.421",
    transform: "translate(-6.551 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_430",
    "data-name": "Pfad 430",
    d: "M18.759,5.051a.448.448,0,1,1-.447.447.448.448,0,0,1,.447-.447m0-1.015A1.462,1.462,0,1,0,20.221,5.5a1.462,1.462,0,0,0-1.462-1.462",
    transform: "translate(-8.522 -1.989)",
    fill: "#fff"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSites);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sites.ce3e3fc1cad795627d72d9c3a557bdc4.svg";